import { Constants } from "../../../../assets/utils/lib/constants";
import Drawer from "../../../../assets/vfx/drawer/drawer";
import Form from "../../../../assets/vfx/form/form";
import { DrawerFormSaveResult, hasClientErrorOperationStatusCode } from "../../../../assets/utils/lib";
import {
  PlanDto,
  SubscriptionDto,
  SubscriptionPlanDto,
} from "../../../../services/dto";
import * as yup from "yup";
import { DropdownOption } from "../../../../assets/vfx/controls/components/dropdown/controlDropdown";

interface SubscriptionPlanFormProps {
  show: boolean;
  plan: PlanDto | undefined;
  subscriptions: SubscriptionDto[];
  onHide: () => void;
  onSave: (values: SubscriptionPlanDto) => DrawerFormSaveResult;
}

const convertToDropdownOptions = (
  subscriptions: SubscriptionDto[]
): DropdownOption[] => {
  return subscriptions.map((sub) => ({
    key: sub.id,
    value: sub.id,
    display: sub.name ?? Constants.emptyString,
  }));
};

const validationSchema = yup.object().shape({
  subscriptionId: yup.string().required("Subscription is required."),
  publishedDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .required("Published date is required."),
  activationDate: yup
    .date()
    .typeError("Please enter a valid date.")
    .nullable()
    .required("Activation date is required."),
});

export const SubscriptionPlanForm = (props: SubscriptionPlanFormProps) => {
  const title: string = `New Subscription for ${
    props.plan?.name ?? Constants.emptyString
  } Plan`;
  const dropdownOptions: DropdownOption[] = convertToDropdownOptions(
    props.subscriptions
  );

  const handleSubmit = (data: SubscriptionPlanDto) => {
    if (props.plan) data.planId = props.plan.id;
    return Promise.resolve(props.onSave(data)).then((result) => {
        if (hasClientErrorOperationStatusCode(result)) {
            return;
        }

        props.onHide();
    });
  };

  return (
    <Drawer.Form
      className="w-30"
      show={props.show}
      backdrop
      placement="end"
      scroll
      title={title}
      initialValues={{}}
      validationSchema={validationSchema}
      enableReinitialize
      on_Submit={handleSubmit}
      onHide={props.onHide}
    >
      <Form.Dropdown
        blankOption={{
          key: Constants.emptyGuid,
          value: Constants.emptyGuid,
          display: "Select Subscription",
        }}
        options={dropdownOptions}
        name={"subscriptionId"}
        label={"Subscription"}
      ></Form.Dropdown>
      <Form.Date
        name="publishedDate"
        label="Published Date"
        placeholder="Enter date"
      />
      <Form.Date
        name="activationDate"
        label="Activation Date"
        placeholder="Enter date"
      />
    </Drawer.Form>
  );
};
